import { Button } from './Button'

export function Footer() {
  return (
    <footer className="bg-secondary py-8">
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-md mx-auto mb-8">
          <h2 className="text-2xl font-bold mb-4 text-foreground">Stay in the Loop</h2>
          <p className="text-muted-foreground mb-6">
            Coming soon to your favorite app store. Get ready to start exploring!
          </p>
          <Button />
        </div>
        <p className="text-muted-foreground">
          © {new Date().getFullYear()} Soonish. All rights reserved.
        </p>
      </div>
    </footer>
  )
} 